import { lazy } from 'react';
export var LessonEditPageAsync = lazy(function () { return import('./LessonEditPage'); });
